module.exports = __webpack_public_path__ + "img/eclair.a6492945.png";